/**
 * @fileoverview
 * See `types.ts` for context on these symbols.
 */

export const SCRAMJETCLIENTNAME = "scramjet client global";
export const SCRAMJETCLIENT = Symbol.for(SCRAMJETCLIENTNAME);
export const SCRAMJETFRAME = Symbol.for("scramjet frame handle");
